import { motion } from "framer-motion";
import { Wallet, Brain, TrendingUp, ShieldCheck, Star, Users } from "lucide-react";

const features = [
  {
    icon: Wallet,
    title: "Group Wallet",
    description: "One shared wallet. Everyone pre-loads their share. No one fronts. No IOUs ever again.",
    accent: "neon",
  },
  {
    icon: Brain,
    title: "AI-Powered Picks",
    description: "Our AI narrows 200 venues to 3 perfect matches based on your group's vibes, budget & size.",
    accent: "gold",
  },
  {
    icon: ShieldCheck,
    title: "Commitment Deposits",
    description: "Lock in with ₹500. Show up, get it back. Bail? The group keeps it. No more flakers.",
    accent: "neon",
  },
  {
    icon: TrendingUp,
    title: "Reliability Score",
    description: "Track who actually shows up. High score = no deposit needed + priority booking perks.",
    accent: "gold",
  },
  {
    icon: Star,
    title: "Krew Leaderboard",
    description: "Track your nights out. Climb the ranks. Top 10% get exclusive venue access & rewards.",
    accent: "neon",
  },
  {
    icon: Users,
    title: "Smart Crew Suggestions",
    description: "We remember your crew. Next time, one tap to reassemble and plan another legendary night.",
    accent: "gold",
  },
];

const FeaturesSection = () => {
  return (
    <section id="features" className="section-padding bg-background">
      <div className="mx-auto max-w-7xl">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="mb-16 text-center"
        >
          <span className="mb-4 inline-block text-sm font-semibold uppercase tracking-widest text-primary">
            Features
          </span>
          <h2 className="mx-auto max-w-2xl text-4xl font-bold md:text-5xl">
            Everything your squad needs.{" "}
            <span className="text-gradient-neon">Nothing it doesn't.</span>
          </h2>
        </motion.div>

        <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
          {features.map((feature, i) => (
            <motion.div
              key={feature.title}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.08 }}
              className={`rounded-2xl border p-8 transition-all ${
                feature.accent === "neon"
                  ? "border-border bg-card hover:border-primary/40"
                  : "border-border bg-card hover:border-secondary/40"
              }`}
            >
              <div
                className={`mb-5 flex h-12 w-12 items-center justify-center rounded-xl ${
                  feature.accent === "neon" ? "bg-primary/10" : "bg-secondary/10"
                }`}
              >
                <feature.icon
                  className={`h-6 w-6 ${
                    feature.accent === "neon" ? "text-primary" : "text-secondary"
                  }`}
                />
              </div>
              <h3 className="mb-2 text-xl font-semibold text-foreground">{feature.title}</h3>
              <p className="text-sm leading-relaxed text-muted-foreground font-body">
                {feature.description}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;
